import { EntityGroup } from "./margin.types";
import { Currency, Instrument, Symbol } from "./settings.types";

export enum TimeZone {
  UTC = 'UTC',
  Local = 'Local'
}

export interface User {
  id: number;
  username: string;
  password?: string;
  enabled: boolean;
  email?: string;
  role?: string;
  picture?: string;
  firm?: any;
  firmId?: number;
  dealCode?: string;
  dealCodeId?: number;
  country?: string;
  city?: string;
  phoneNumber?: string;
  annonId?: number;
  useOnLiquidation?: boolean;
  lastLogin?: string;
}

export enum UserGroups {
  admin = 'admin',
  trader = 'trader',
  traderRO = 'trader-ro',
  traderViewOnly = 'trader-view-only',
  credit = 'credit',
  engineering = 'engineering',
  businessOps = 'business-ops'
}

export interface Firm {
  id: number; 
  anonId?: number;
  externalId?: number;
  active: boolean;
  email: string;
  notificationEmail: string;
  executingBroker: boolean; 
  firmId: string; 
  firmName: string;
  firmType: string;
  primeBroker: boolean; 
  primeClient: boolean;
  marginClient: boolean;
  details: DealCode[];
  parentFirmId?: number;
  parentFirmName?: string;
  parentFirmFirmId?: string;
  homeCcy?: Currency;
  address?: string;
  phoneNumber?: string;
  entityGroup?: EntityGroup;
  rfsClient: boolean;
  ecnClient: boolean;
  fullAmountClient: boolean;
  reactiveEspFullAmountLadderAccount?: string;
  reactiveEspFullAmountStackAccount?: string;
  reactiveEspSweepableAccount?: string;
  reactiveRfsAccount?: string;
  test: boolean;
  spotEcnClient: boolean;
  forwardEcnClient: boolean;
  ndfEcnClient: boolean;
  swapRfsClient?: boolean;
  pbs: Firm[];
}

export enum FirmType {
  BANK = 'BANK',
  HEDGE_FUND = 'HEDGE FUND',
  PB = 'PRIME BROKER'
}

export interface DealCode {
  id: number;
  enabled: boolean;
  firmIdentifier: number;
  firmId: string;
  firmName?: string;
  dealCode: string;
  dealCodeName: string;
  liquidityTaker: boolean;
  liquidityMaker: boolean;
  liquidityPool: string;
  details: User[];
  streams?: any[];
  makerSessions?: any;
}

export interface LiquidityPool {
  id: number;
  liquidityPoolName: string;
  streamInstruments: StreamInstrument[];
  details?: StreamInstrument[];
  disableDetails?: boolean;
  dealCodes?: {};
}

export interface StreamInstrument {
  id: number;
  stream: any;
  instruments: Instrument[];
}

export interface LiquidityProvider {
  id: number;
  name: string;
}

export interface MexVenue {
  id: number;
  venueName: string;  
  reactiveVenueName: string;
  venueDto?: any;
}

export interface MexVenueSymbol {
  id: number;
  venue: MexVenue;
  symbolTenor: Instrument;
  venueCcyPair: string;
  enabled: boolean;
}

export interface MexVenueCpty {
  id: number;
  mexVenue: MexVenue;
  mexCounterPartyCode: string;
  venueCounterPartyCode: string;
}

export interface MexVenueAccount {
  id: number;
  mexVenue: MexVenue;
  mexAccountCode: string;
  venueAccountCode: string;
}

export interface ClientEntitlement {
  id: number;
  enabled: boolean;
  forward: boolean;
  ndf: boolean;
  ndfswap: boolean;
  spot: boolean;
  swap: boolean;
  firm: Firm;
  liquidityProvider: LiquidityProvider;
  symbol: Symbol;
}

export interface ClientGroup {
  id: number;
  firms: Firm[];
  liquidityProvider: LiquidityProvider;
  streamingType: string
}